import React from 'react';

import './index.less';

import Icon from './../basic-icon';

export default () => {
    return (
        <div className="loading">
            <Icon type="icon-loading"></Icon>Loading...
        </div>
    );
}